import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreDefaultRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-core-redirect',
	path: '/jira/core/projects/:projectKey/settings',
};
